module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 col-md-offset-1"
  }, [_c('a', {
    attrs: {
      "href": "http://www.wtfpl.net/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/wtfpl-badge-2.png",
      "width": "80",
      "height": "15",
      "alt": "WTFPL"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8b129bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Copyright.vue
// module id = 110
// module chunks = 0